import React from "react"
import styled from "styled-components"
import { StaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"

import { Settings } from "../../../styles/theme"

import { Card } from "../../atoms/card"
import { Grid } from "../../atoms/grid"

import { withLightbox } from "../../molecules/lightbox"

const NewsbyteListStyled = styled.div`
  position: relative;
  .headers {
    border-bottom: 3px solid ${Settings.secondaryColor};
    margin-bottom: 2rem;
    @media screen and (max-width: ${Settings.sizeM}) {
      display: none;
    }
    a {
      display: inline-block;
      margin: 0 1rem;
      cursor: pointer;
      h4 {
        color: rgba(0, 0, 0, 1);
      }
    }
    a.active {
      h4 {
        color: ${Settings.secondaryColor};
      }
    }
  }
  .hide {
    display: none;
  }
  .card {
    > div {
      padding: 1rem;
    }
  }
  .more {
    background: none;
    color: ${Settings.primaryColor};
    padding-bottom: 5rem;
    border: none;
    font-size: 1.5rem;
    font-weight: 700;
    text-transform: uppercase;
    position: relative;
    outline: none;
    cursor: pointer;
    &:after {
      content: "${props => (props.toggle ? "︿" : "﹀")}";
      position: absolute;
      bottom 3rem;
      left: 50%;
      font-weight: 700;
      transform: translateX(-50%);
    }
  }
  .mobileNav {
    display: none;
    border-bottom: 2px solid ${Settings.secondaryColor};
    .nav {
      position: relative;
    }
    .nav {
      h4,
      b {
        display: inline-block;
        margin: 1rem 0;
      }
    }
    b {
      font-size: 2rem;
      color: ${Settings.secondaryColor};
      float: right;
    }
    @media screen and (max-width: ${Settings.sizeM}) {
      display: block;
      h4 {
        color: ${Settings.secondaryColor};
        font-weight: 700;
        font-size: 1.5rem;
      }
    }
    .dropdown {
      display: none;
      position: absolute;
      top: 5rem;
      left: 50%;
      background: #fff;
      width: 100%;
      box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.5);
      z-index: 100;
      width: 90%;
      transform: translateX(-50%);
      h4 {
        margin: 2rem;
      }
    }
    .dropdown.show {
      display: block;
    }
  }
`

const Cardcategory = styled.div`
  position: relative;
  display: ${props => (props.selected ? "block" : "none")};
`

const Newsbyte = ({
  selected,
  setSelected,
  toggle,
  toggleLightbox,
  init,
  setInit,
}) => (
  <StaticQuery
    query={graphql`
      query NewsbyteQuery {
        allContentfulNewsbyte {
          edges {
            node {
              id
              title
              publishedDate(formatString: "DD MMMM YYYY")
              banner {
                fluid {
                  ...GatsbyContentfulFluid
                }
              }
            }
          }
        }
        allContentfulNewsbyteCategory {
          edges {
            node {
              id
              title
              newsbytes {
                title
                publishedDate(formatString: "DD MMMM YYYY")
                banner {
                  fluid {
                    ...GatsbyContentfulFluid
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={data => (
      <NewsbyteListStyled toggle={toggle}>
        <div className="headers constraint">
          <a
            onClick={() => setSelected(0)}
            className={selected === 0 ? "active" : ""}
          >
            <h4>All</h4>
          </a>
          {data.allContentfulNewsbyteCategory.edges.map((category, i) => (
            <a
              onClick={() => setSelected(i + 1)}
              className={selected === i + 1 ? "active" : ""}
            >
              <h4>{category.node.title}</h4>
            </a>
          ))}
        </div>
        <div className="constraint mobileNav">
          <div className="nav" onClick={() => setInit(!init)}>
            <h4>
              {selected === 0
                ? "All"
                : data.allContentfulNewsbyteCategory.edges[selected - 1].node
                    .title}
            </h4>
            <b>⌄</b>
          </div>
          <div className={init ? "dropdown show" : "dropdown"}>
            <div>
              <h4
                onClick={() => {
                  setSelected(0)
                  setInit(!init)
                }}
                className={selected === 0 ? "selected" : ""}
              >
                All
              </h4>
            </div>
            {data.allContentfulNewsbyteCategory.edges.map((category, i) => (
              <div>
                <h4
                  key={i}
                  onClick={() => {
                    setSelected(i + 1)
                    setInit(!init)
                  }}
                  className={selected === i ? "selected" : ""}
                >
                  {category.node.title}
                </h4>
              </div>
            ))}
          </div>
        </div>
        <div className="results">
          <div className="constraint">
            <Grid>
              {selected === 0
                ? data.allContentfulNewsbyte.edges.map((newsbyte, i) => (
                    <div
                      className={
                        i + 1 > 6 && toggle === false ? "hide" : "card"
                      }
                    >
                      <Card key={i + 1} object={newsbyte.node} />
                    </div>
                  ))
                : ""}
              {data.allContentfulNewsbyteCategory.edges.map((category, i) => {
                return selected === 0 ? (
                  ""
                ) : (
                  <Cardcategory key={i} selected={selected === i + 1}>
                    <div className="constraint">
                      <Grid>
                        {category.node.newsbytes
                          ? category.node.newsbytes.map((news, i) => (
                              <div
                                className={
                                  i > 6 && toggle === false ? "hide" : "card"
                                }
                              >
                                <Card key={i + 1} object={news} />
                              </div>
                            ))
                          : ""}
                      </Grid>
                    </div>
                  </Cardcategory>
                )
              })}
            </Grid>
            <div style={{ textAlign: "center" }}>
              {selected === 0 ? (
                data.allContentfulNewsbyte.edges.length > 6 ? (
                  toggle ? (
                    <button className="more" onClick={toggleLightbox}>
                      Less
                    </button>
                  ) : (
                    <button className="more" onClick={toggleLightbox}>
                      More
                    </button>
                  )
                ) : (
                  ""
                )
              ) : data.allContentfulNewsbyteCategory.edges[selected - 1]
                  .length > 6 ? (
                toggle ? (
                  <button className="more" onClick={toggleLightbox}>
                    Less
                  </button>
                ) : (
                  <button className="more" onClick={toggleLightbox}>
                    More
                  </button>
                )
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </NewsbyteListStyled>
    )}
  />
)

export const NewsbyteList = withLightbox(Newsbyte)

const CardCluster = styled.div`
  position: relative;
  flex: 1 !important;
  display: block;
  @media screen and (max-width: ${Settings.sizeM}) {
    flex: 1 1 100%;
  }
  a {
    text-decoration: none !important;
    > div {
      height: 100%;
    }
  }
  .gatsby-image-wrapper {
    margin: 0;
  }
  .content {
    margin: 0;
    background: #f4f4f4;
    text-align: left;
    > div {
      padding: 1rem;
    }
    h4 {
      color: ${Settings.primaryColor};
      font-size: ${props => (props.first ? "1.2rem" : "1rem")};
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
      margin: 0;
      padding-bottom: 0.5rem;
    }
  }
`

const NewsbyteClusterStyle = styled.div`
  > div {
    justify-content: space-between;
    align-items: stretch;
  }
  a:hover > div {
    transition: all 175ms ease-in-out;
    transform: scale(1.05);
    box-shadow: 5px 5px 8px #c6c6c6;
  }
  h4 {
    max-height: 4.5rem;
    overflow: hidden;
  }
  .side-wrap {
    display: flex;
    flex: 1;
    @media screen and (max-width: ${Settings.sizeM}) {
      flex: 1 1 100%;
    }
    flex-direction: column;
    justify-content: space-between;
    > div {
      display: block;
      margin: 1rem;
      a {
        div {
          height: 100%;
        }
      }
    }
  }
`

export const NewsbyteCluster = ({ data }) => (
  <NewsbyteClusterStyle>
    <Grid columns={2}>
      <CardCluster first>
        <Link
          to={
            "newsbyte/" +
            data.edges[0].node.title
              .replace(/\s+/g, "-")
              .replace(/[!@#$%^&*?]/g, "")
              .toLowerCase()
          }
        >
          <div style={{ margin: "1rem" }}>
            <Img fluid={data.edges[0].node.banner.fluid} />
            <div className="content">
              <div>
                <h4>{data.edges[0].node.title}</h4>
                <p>{data.edges[0].node.publishedDate}</p>
              </div>
            </div>
          </div>
        </Link>
      </CardCluster>
      <div className="side-wrap">
        {data.edges.slice(1, 4).map((edge, i) => (
          <CardCluster key={i}>
            <Link
              to={
                "newsbyte/" +
                edge.node.title
                  .replace(/\s+/g, "-")
                  .replace(/[!@#$%^&*?]/g, "")
                  .toLowerCase()
              }
            >
              <Grid unstack columns={2}>
                <div style={{ flex: "1 1 30%" }}>
                  <Img fluid={edge.node.banner.fluid} />
                </div>
                <div className="content" style={{ flex: "1 1 60%" }}>
                  <div>
                    <h4>{edge.node.title}</h4>
                    <p>{edge.node.publishedDate}</p>
                  </div>
                </div>
              </Grid>
            </Link>
          </CardCluster>
        ))}
      </div>
    </Grid>
  </NewsbyteClusterStyle>
)
